export default {"src":"/_next/static/media/homesalt.0ef7fc37.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};